<div class="gridLayout">
	<sim-list [label]="T.SESSION_CREATION_DIALOG_USER_GROUP_SELECTION" icon="fa-object-group">
		<ng-container actions>
			<sim-autocomplete
				(onSelect)="addUserGroup($any($event))"
				[dataType]="FetchDataType.SimGroup"
				[excludeIds]="excludeIds()"
				[labelToken]="T.CREATE_SESSION_SELECT_GROUP"
				[searchFilters]="{searchColumn: 'Type', searchTerms: ['UserSubGroup']}"
				subscriptSizing="dynamic"
			>
				<mat-icon fontIcon="fa-object-group" fontSet="fad" labelPrefix />
			</sim-autocomplete>
		</ng-container>
		@for (group of viewGroups(); track group.id) {
			<sim-list-item
				[selected]="selectedGroup()?.id === group.id"
				[primaryLabel]="group.name"
				[secondaryLabel]="group.memberIds?.length + ' ' + (T.GROUP_MANAGER_PAGE_GROUP_MEMBERS | translate)"
				(click)="selectedGroup.set(group)"
			>
				<ng-container actions>
					<button mat-icon-button color="warn" (click)="removeUserGroup(group)">
						<mat-icon fontIcon="fa-times" fontSet="fas" inline />
					</button>
				</ng-container>
			</sim-list-item>
		}
	</sim-list>

	<mat-divider vertical />

	<sim-list [label]="T.LABEL_GROUP_MEMBERS" icon="fa-users">
		@if (groupMembers().length) {
			@for (member of groupMembers(); track member.id) {
				<sim-user-list-item
					[user]="member"
					[selected]="selectedMember()?.id === member.id"
					[showOnClickDialog]="false"
					(click)="selectedMember.set(member)"
				/>
			}
		} @else {
			<ng-container emptyState>
				<mat-icon fontIcon="fa-users-slash" fontSet="fad" />
				{{ T.CREATE_SESSION_GROUP_EMPTY_HINT | translate }}
			</ng-container>
		}
	</sim-list>

	@if (selectedMember()) {
		<sim-user-details [user]="selectedMember()" [@zoomOutOnLeave] [@zoomInOnEnter] />
	}
</div>
